export type ProjectCategory =
  | "web3"
  | "frontend"
  | "fullstack"
  | "mobile"
  | "desktop";
export type ProjectStatus = "active" | "done" | "wip";

export interface ProjectBase {
  id: string;
  number: string;
  category: ProjectCategory;
  status: ProjectStatus;
  tags: string[];
  url?: string;
  urlLabel?: string;
}

export interface Project extends ProjectBase {
  title: string;
  description: string;
  statusLabel: string;
}

export const FEATURED_PROJECTS: ProjectBase[] = [
  {
    id: "juneoWebWallet",
    number: "02",
    category: "web3",
    status: "active",
    tags: ["React", "TypeScript", "JuneoJS", "Zustand"],
    url: "https://juneowallet.io/",
    urlLabel: "juneowallet.io",
  },
  {
    id: "juneoPortal",
    number: "03",
    category: "web3",
    status: "active",
    tags: ["React", "Ethers.js", "Node.js", "WebSocket"],
    url: "https://portal.juneo.com/",
    urlLabel: "portal.juneo.com",
  },
  {
    id: "juneoWalletExtension",
    number: "04",
    category: "web3",
    status: "active",
    tags: ["React", "Chrome API", "JuneoJS"],
    url: "https://chromewebstore.google.com/detail/juneo-wallet/bmbgpekfibflcgcojpalgfohfnbebofl",
    urlLabel: "Chrome Store",
  },
  {
    id: "juneoMobileWallet",
    number: "05",
    category: "mobile",
    status: "active",
    tags: ["React Native", "Expo", "Biometrics"],
    url: "https://juneowallet.io/",
    urlLabel: "juneowallet.io",
  },
  {
    id: "juneoWebsite",
    number: "06",
    category: "frontend",
    status: "active",
    tags: ["React", "GSAP", "i18n", "Vite"],
    url: "https://juneo.com/",
    urlLabel: "juneo.com",
  },
  {
    id: "supernetBridge",
    number: "01",
    category: "web3",
    status: "active",
    tags: ["React", "Solidity", "Wagmi", "Docker"],
    url: "https://supernetbridge.io/",
    urlLabel: "supernetbridge.io",
  },
];

export const MORE_PROJECTS: ProjectBase[] = [
  {
    id: "nestohm",
    number: "07",
    category: "fullstack",
    status: "active",
    tags: ["React", "Node.js", "PostgreSQL", "Docker"],
    url: "https://nestohm.com/",
    urlLabel: "nestohm.com",
  },
  {
    id: "naturaSelect",
    number: "08",
    category: "frontend",
    status: "active",
    tags: ["React", "TypeScript", "Shopify", "Vite"],
    url: "https://natura-select.com/",
    urlLabel: "natura-select.com",
  },
  {
    id: "fourByFourVert",
    number: "09",
    category: "frontend",
    status: "done",
    tags: ["React", "GSAP", "TypeScript"],
    url: "https://4x4vert.be/",
    urlLabel: "4x4vert.be",
  },
  {
    id: "falcohmSystem",
    number: "10",
    category: "frontend",
    status: "active",
    tags: ["React", "GSAP", "TypeScript"],
    url: "http://falcohmsystem.com/",
    urlLabel: "falcohmsystem.com",
  },
  {
    id: "mcnNodeManager",
    number: "11",
    category: "desktop",
    status: "active",
    tags: ["TypeScript", "Electron", "JuneoGo", "Node"],
  },
  {
    id: "mcnAuction",
    number: "12",
    category: "web3",
    status: "active",
    tags: ["Solidity", "JuneoJS", "Dutch Auction", "P-Chain"],
  },
  {
    id: "juneoOnChainBots",
    number: "13",
    category: "web3",
    status: "active",
    tags: ["TypeScript", "JuneoJS", "MEV", "DEX", "Arbitrage"],
  },
  {
    id: "juneoWhaleAlert",
    number: "14",
    category: "web3",
    status: "active",
    tags: ["TypeScript", "JuneoJS", "Telegram Bot"],
  },
  {
    id: "juneoMultisig",
    number: "15",
    category: "web3",
    status: "active",
    tags: ["React", "Solidity", "JuneoJS", "Gnosis Safe", "Multisig"],
  },
  {
    id: "wpmc",
    number: "16",
    category: "fullstack",
    status: "wip",
    tags: ["Java", "Minecraft", "Spigot", "MySQL"],
  },
  {
    id: "wps",
    number: "17",
    category: "desktop",
    status: "wip",
    tags: ["C#", "Unity", "RTS", "Multiplayer"],
  },
  {
    id: "projectTribes",
    number: "18",
    category: "desktop",
    status: "wip",
    tags: ["C#", "Unity", "Strategy", "Multiplayer"],
  },
  {
    id: "cortex",
    number: "19",
    category: "web3",
    status: "wip",
    tags: ["TypeScript", "Node.js", "Blockchain", "Staking", "Docker"],
  },
];

export const ALL_PROJECTS: ProjectBase[] = [
  ...FEATURED_PROJECTS,
  ...MORE_PROJECTS,
];
